import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=23a96200&scoped=true"
import script from "./Sustainability.vue?vue&type=script&lang=js"
export * from "./Sustainability.vue?vue&type=script&lang=js"
import style0 from "./Sustainability.vue?vue&type=style&index=0&id=23a96200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a96200",
  null
  
)

export default component.exports